<template>
  <div v-editable="blok" class="blog-card">
    <BaseNuxtImage
      v-if="blok.image"
      :src="blok.image.filename"
      :alt="blok.image.alt"
      :class="['blog-card__image', `blog-card__image--${blok.image_position}`]"
      :style="imageStyle"
      width="268"
      height="auto"
    />
    <div class="blog-card__content">
      <p class="blog-card__subtitle">
        {{ blok.subtitle }}
      </p>
      <h3 class="blog-card__title">
        {{ blok.title }}
      </h3>
      <BaseLink :target="target" :address="blok.button_link">
        <BaseButton :title="blok.button_text">
          <template #text>
            {{ blok.button_text }}
          </template>
        </BaseButton>
      </BaseLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbBlogLinkCard } from '@/types'

interface Props {
  blok: SbBlogLinkCard
}
const props = defineProps<Props>()

const target = computed(() => {
  return props.blok.new_window ? '_blank' : '_self'
})

const imageStyle = computed(() => {
  return {
    width: `${props.blok.image_width || 268}px`,
  }
})
</script>

<style lang="scss" scoped>
.blog-card {
  overflow: hidden;
  width: 100%;
  border-radius: 20px;
  position: relative;
  padding: 52px;
  background-color: var(--gray-200);

  @media (min-width: $breakpoint-md) {
    width: calc(100% + 96px);
    right: 48px;
  }

  &__content {
    position: relative;
    max-width: 360px;
  }

  &__subtitle {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 9px;
    margin-bottom: 14px;
    border: 1px solid var(--navy-600);
    font-size: var(--font-size-paragraph-2xs);
    line-height: var(--font-size-paragraph-s);
  }

  &__title {
    margin-bottom: 86px;
  }

  &__image {
    opacity: 0.4;
    z-index: 0;
    width: 268px;
    position: absolute;
    right: 52px;
    bottom: 52px;

    @media (min-width: $breakpoint-md) {
      opacity: 1;
    }

    &--bottom {
      bottom: 0;
    }

    &--right {
      right: 0;
    }

    &--bottom-right {
      bottom: 0;
      right: 0;
    }
  }
}
</style>
